import { AudienceOptions, SendOptions } from '../../../../../../modals/push-notifications/campaign/Constants';

export default {
  title: 'Opret push-notifikationskampagne',
  sent_title: 'Notifikation sat i kø',
  sent_subtitle:
    'Din push-notifikation er sendt til Apple og Google. Leveringsbekræftelser modtages om cirka 15 minutter.',
  sent_info_banner:
    'Du kan lukke denne dialog. Vi fortsætter med at tjekke og opdaterer kampagnens leveringsstatistik automatisk.',
  circles: {
    sent_label: 'Sendt',
    sent_sub: 'Sendt til abonnenter',
    delivered_label: 'Leveret',
    delivered_sub: 'Venter på Apple og Google',
    delivered_ready_short: 'Klar',
    delivered_ready_sub: 'Opdater for at se de seneste statistikker',
  },
  scheduled_title: 'Kampagne planlagt',
  scheduled_body_line_1: 'Din push-notifikation er planlagt til {{when}}.',
  scheduled_body_line_2:
    'Vi sender den automatisk på det tidspunkt. Leveringsbekræftelser fra Apple og Google er tilgængelige cirka 15 minutter efter afsendelse.',
  recipients_count_one: 'Sendt til {{count}} abonnent.',
  recipients_count_other: 'Sendt til {{count}} abonnenter.',
  close: 'Luk',
  sections: {
    message: 'Besked',
    audience: 'Målgruppe',
    when: 'Hvornår skal den sendes',
    review: 'Gennemse',
  },
  stepper: {
    message: 'Besked',
    audience_when: 'Hvornår skal den sendes',
    review: 'Gennemse',
  },
  blocked_reasons: {
    title_required: 'Tilføj en titel for at fortsætte.',
    body_required: 'Tilføj en beskedtekst for at fortsætte.',
    offer_required: 'Vælg et tilbud for at fortsætte.',
    promo_code_required: 'Vælg en rabatkode for at fortsætte.',
    send_option_required: 'Vælg, hvornår der skal sendes, for at fortsætte.',
    scheduled_at_required: 'Vælg dato og tidspunkt for at fortsætte.',
  },
  fields: {
    title: {
      label: 'Titel',
      placeholder: 'Indtast notifikationens titel',
    },
    body: {
      label: 'Beskedtekst',
      placeholder: 'Indtast din besked',
    },
    audience: {
      label: 'Målgruppe',
    },
    send_options: {
      label: 'Afsendelsesmuligheder',
    },
    date_and_time: {
      label: 'Dato og tidspunkt',
      placeholder: 'Vælg dato og tidspunkt',
    },
  },
  send_options: {
    [SendOptions.Now]: 'Send nu',
    [SendOptions.Schedule]: 'Planlæg',
  },
  send_option_cards: {
    now: {
      title: 'Send nu',
      description: 'Send til alle abonnenter med det samme.',
    },
    schedule: {
      title: 'Planlæg',
      description: 'Vælg en dato og et tidspunkt i fremtiden.',
    },
  },
  campaign_type_cards: {
    promotional: {
      title: 'Salgsfremmende 🚀',
      description: 'Promover et tilbud eller en rabatkode.',
    },
    informational: {
      title: 'Informativ ℹ️',
      description: 'Del nyheder eller en opdatering – uden tilknyttet rabat.',
    },
  },
  audience: {
    [AudienceOptions.All]: 'Alle brugere ({{count}} enhed)',
  },
  preview: {
    title: 'Forhåndsvisning',
    notifications: {
      title: 'Din notifikationstitel vises her',
      body: 'Din beskedtekst vises her med alle detaljer...',
      now: 'Nu',
    },
    estimated_reach: 'Rækkevidde',
  },
  summary: {
    title: 'Oversigt',
    reach: 'Rækkevidde',
    when: 'Hvornår',
    campaign_type: 'Kampagnetype',
    promo_code: 'Rabatkode',
    offer: 'Tilbud',
    test_audience: 'Send en test-push først',
  },
  alerts: {
    daily_limit_reached: {
      title: 'Daglig afsendelsesgrænse nået',
      description:
        'Hej! Hvis du sender mere end 1 push-notifikation om dagen, bliver brugerne utilfredse, og det kan føre til, at de sletter appen. Derfor begrænser vi manuelle push-beskeder til 1 om dagen. Planlæg denne til i morgen.',
    },
    offer_not_sendable: {
      title: 'Tilbuddet gælder ikke i dag',
      description: 'Vælg en dato i fremtiden.',
    },
  },
  buttons: {
    send_now: 'Send nu',
    save: 'Gem',
    save_as_draft: 'Gem som kladde',
    send_test: 'Send test',
    draft_with_ai: 'Skriv udkast med AI',
    back: 'Tilbage',
    next: 'Næste',
  },
  feedback: {
    success: 'Kampagnen er gemt',
    promo_code_expired: 'Rabatkoden er udløbet',
    error: 'Kampagnen kunne ikke gemmes. Tjek din forbindelse, og prøv igen.',
  },
};
